import React from 'react';
import {inject, observer} from 'mobx-react';
import {Redirect} from 'react-router-dom'

@inject('userStore', 'navigatorStore', 'authStore', 'landingPageArtworksStore', 'artworksStore', 'artistDetails', 'categoryPageArtworksStore')
@observer
export default class ArtistOfTheMonthSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handleViewArtistProfile(username) {
        this.setState({
            toProfile: true,
            username: username
        })
    }
    handleViewArworkDetails(slug) {
        this.setState({
            toArtwork: true,
            slug: slug
        })
    }
    render() {
        if (this.state.toProfile) {
            return (
                <Redirect push to={`/profile/details/${this.state.username}`} />
            )
        }
        if (this.state.toArtwork) {
            return (
                <Redirect push to={`/product/details/${this.state.slug}`} />
            )
        }
        if (this.props.colored && !!this.props.AOTMdata) {
            return (
                <div className="container-rectangle-colored" ref={this.artistsRef} >
                    <div className="rectangle-colored">

                        <div style={{ display: "flex" }}>
                            <div className="title-featured-artworks mt-15" style={{ margin: "unset", flex: "1" }}>
                                ARTIST IN SPOTLIGHT
                        <hr className="line-category-name "></hr>
                            </div>
                        </div>

                        <div className="mt-15 mb-15 pb-15">

                            <div className="row">

                                <div className="col-md-3 text-center">

                                    <img
                                        onClick={() => this.handleViewArtistProfile(this.props.AOTMdata.artist_share_url.substr(this.props.AOTMdata.artist_share_url.lastIndexOf("/") + 1))}
                                        // onClick={()=>this.handleViewArtistProfile(this.props.AOTMdata.artist_share_url)}
                                        src={this.props.AOTMdata.artist_image_url}
                                        className="month-image "
                                        alt={this.props.AOTMdata.artist_name} />

                                    <div className="artist-month-button-block text-center mt-25 mb-25">
                                        <button className="masterpieces-primary-buttons button month-btn"
                                            onClick={() => this.handleViewArtistProfile(this.props.AOTMdata.artist_share_url.substr(this.props.AOTMdata.artist_share_url.lastIndexOf("/") + 1))}
                                        >
                                            VIEW PROFILE
                                </button>
                                    </div>

                                </div>

                                <div className="col-md-9">

                                    <h3 className="artist-month-heading">{this.props.AOTMdata.artist_name}</h3>
                                    <hr className="line-category-name "></hr>

                                    <div className="location month-artist-loc">
                                        <img src={require('../../assets/location.png')} alt="location"
                                             className="location-img" />
                                        {(this.props.AOTMdata.artist_country)}
                                    </div>

                                    <h5 className="artist-month-desc">
                                     Browse through their impeccable pieces of work here.
                                    </h5>

                                    <div className="row mt-25 mb-25">
                                        <div className="col-md-4 artwork-block-month">
                                            <a onClick={() => this.handleViewArworkDetails(this.props.AOTMdata.artwork_share_url_1.substr(this.props.AOTMdata.artwork_share_url_1.lastIndexOf("/") + 1))}>

                                                <img
                                                    src={this.props.AOTMdata.artwork_image_url_1}
                                                    className="month-artwork-image" />
                                            </a>
                                        </div>
                                        <div className="col-md-4 artwork-block-month">
                                            <a onClick={() => this.handleViewArworkDetails(this.props.AOTMdata.artwork_share_url_2.substr(this.props.AOTMdata.artwork_share_url_2.lastIndexOf("/") + 1))}>

                                                <img
                                                    src={this.props.AOTMdata.artwork_image_url_2}
                                                    className="month-artwork-image" />
                                            </a >
                                        </div>
                                        <div className="col-md-4 artwork-block-month">
                                            <a onClick={() => this.handleViewArworkDetails(this.props.AOTMdata.artwork_share_url_3.substr(this.props.AOTMdata.artwork_share_url_3.lastIndexOf("/") + 1))}>

                                                <img
                                                    src={this.props.AOTMdata.artwork_image_url_3}
                                                    className="month-artwork-image" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        else if (!!this.props.AOTMdata) return (
            <div className="rectangle-featured-artworks">
                <div style={{ display: "flex" }}>
                    <div className="title-featured-artworks mt-15" style={{ margin: "unset", flex: "1" }}>
                        ARTIST IN SPOTLIGHT
                        <hr className="line-category-name "></hr>
                    </div>
                </div>

                <div className="mt-15 mb-15 pb-15">

                    <div className="row">

                        <div className="col-md-3 text-center">

                            <img
                                onClick={() => this.handleViewArtistProfile(this.props.AOTMdata.artist_share_url.substr(this.props.AOTMdata.artist_share_url.lastIndexOf("/") + 1))}
                                // onClick={()=>this.handleViewArtistProfile(this.props.AOTMdata.artist_share_url)}
                                src={this.props.AOTMdata.artist_image_url}
                                className="month-image "
                                alt={this.props.AOTMdata.artist_name} />

                            <div className="artist-month-button-block text-center mt-25 mb-25">
                                <button className="masterpieces-primary-buttons button month-btn"
                                    onClick={() => this.handleViewArtistProfile(this.props.AOTMdata.artist_share_url.substr(this.props.AOTMdata.artist_share_url.lastIndexOf("/") + 1))}
                                >
                                    VIEW PROFILE
                                </button>
                            </div>

                        </div>

                        <div className="col-md-9">

                            <h3 className="artist-month-heading">{this.props.AOTMdata.artist_name}</h3>
                            <hr className="line-category-name "></hr>
                            <div className="location month-artist-loc">
                                <img src={require('../../assets/location.png')} alt="location"
                                     className="location-img" />
                                {(this.props.AOTMdata.artist_country)}
                            </div>
                            <h5 className="artist-month-desc">
                                 Browse through their impeccable pieces of work here.
                            </h5>

                            <div className="row mt-25 mb-25">
                                <div className="col-md-4 artwork-block-month">
                                    <a onClick={() => this.handleViewArworkDetails(this.props.AOTMdata.artwork_share_url_1.substr(this.props.AOTMdata.artwork_share_url_1.lastIndexOf("/") + 1))}>

                                        <img
                                            src={this.props.AOTMdata.artwork_image_url_1}
                                            className="month-artwork-image" />
                                    </a>
                                </div>
                                <div className="col-md-4 artwork-block-month">
                                    <a onClick={() => this.handleViewArworkDetails(this.props.AOTMdata.artwork_share_url_2.substr(this.props.AOTMdata.artwork_share_url_2.lastIndexOf("/") + 1))}>

                                        <img
                                            src={this.props.AOTMdata.artwork_image_url_2}
                                            className="month-artwork-image" />
                                    </a >
                                </div>
                                <div className="col-md-4 artwork-block-month">
                                    <a onClick={() => this.handleViewArworkDetails(this.props.AOTMdata.artwork_share_url_3.substr(this.props.AOTMdata.artwork_share_url_3.lastIndexOf("/") + 1))}>

                                        <img
                                            src={this.props.AOTMdata.artwork_image_url_3}
                                            className="month-artwork-image" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        )
        return (
            <div></div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/sectionHolders/artistOfTheMonthSection.js